import { CalendarMonth, Description, Person, Public, Work } from '@mui/icons-material';
import type { FilterSection } from '../../../components/ui/filterPanel/filterPanel.types';
import type { EmployeeRow } from '../employeeTypes';

/**
 * Sections mirror the column picker groups (columnGroups.ts) exactly.
 * Icons are reused from the same source so picker and filter panel stay in sync.
 *
 * Field order within each section: list/boolean filters first (actionable),
 * then text, then date (less commonly used for filtering).
 *
 * Kept in its own module (no component export) so the filter-key constant below
 * can be shared without tripping react-refresh's only-export-components rule.
 */
export const EMPLOYEE_FILTER_SECTIONS: FilterSection<EmployeeRow>[] = [
  {
    icon: <Person sx={{ fontSize: '0.95rem', color: 'primary.main' }} />,
    titleKey: 'employeeList.filters.sections.identity',
    fields: ['marital_status', 'birthdate'],
  },
  {
    icon: <Public sx={{ fontSize: '0.95rem', color: 'primary.main' }} />,
    titleKey: 'employeeList.filters.sections.location',
    fields: ['field_code', 'country'],
  },
  {
    icon: <CalendarMonth sx={{ fontSize: '0.95rem', color: 'primary.main' }} />,
    titleKey: 'employeeList.filters.sections.employmentDates',
    fields: [
      'entry_date',
      'initial_start_date',
      'contract_start_date',
      'contract_end_date',
      'update_date',
    ],
  },
  {
    icon: <Description sx={{ fontSize: '0.95rem', color: 'primary.main' }} />,
    titleKey: 'employeeList.filters.sections.contractInformation',
    fields: [
      'contract_type',
      'contract_creation_type',
      'contract_trial_period',
      'contract_activity_rate',
    ],
  },
  {
    icon: <Work sx={{ fontSize: '0.95rem', color: 'primary.main' }} />,
    titleKey: 'employeeList.filters.sections.positionRemuneration',
    fields: ['job_function', 'contract_level', 'contract_salary_scale'],
  },
];

/** Flat list of the fields the advanced panel manages — the "scoped" keys for the
 *  deferred-draft layer (`useDraftFilters`). Column-row-only fields are excluded. */
export const EMPLOYEE_ADVANCED_FILTER_KEYS: (keyof EmployeeRow)[] =
  EMPLOYEE_FILTER_SECTIONS.flatMap(s => s.fields);
